import { FC } from "react";
import styled from "styled-components";

import { Td } from "@/components/Table";
import { InstagramSearchImageResource } from "@/types/resources";
import Text from "@/components/Text";
import { Checkbox, CheckboxHolder, CheckboxLabel } from "./ImagesTable";
import Image from "@/components/Image";

const LinkTd = styled(Td)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledImage = styled(Image)`
  object-fit: contain;
  height: 200px;
  width: 200px;
`;

interface Props {
  image: InstagramSearchImageResource;
  selectedImages: number[];
  setSelectedImages: React.Dispatch<React.SetStateAction<number[]>>;
}

const ImagesTableRow: FC<Props> = ({
  image,
  selectedImages,
  setSelectedImages,
}) => {
  return (
    <>
      <tr>
        <Td>
          <CheckboxHolder>
            <Checkbox
              id={`image-${image.id}`}
              name="image"
              type="checkbox"
              checked={selectedImages.includes(image.id)}
              onChange={() => {
                selectedImages.includes(image.id)
                  ? setSelectedImages((prev) =>
                      prev.filter((item) => item !== image.id)
                    )
                  : setSelectedImages((prev) => [...prev, image.id]);
              }}
            />
            <CheckboxLabel htmlFor={`image-${image.id}`} />
          </CheckboxHolder>
        </Td>
        <Td>
          <a href={image.image_url} target="blank" rel="nofollow">
            <StyledImage src={image.image} />
          </a>
        </Td>
        <LinkTd>
          <Text
            as="a"
            target="blank"
            $type="smallBold"
            rel="nofollow"
            href={`https://www.instagram.com/${image.username}`}
          >
            {image.username}
          </Text>
        </LinkTd>
        <Td>{image.times_repeated}</Td>
        <Td>{image.likes_count}</Td>
      </tr>
    </>
  );
};

export default ImagesTableRow;
